import { Link } from "gatsby"
import React from "react"

export const HeaderLinkMobile = ({ label, link }) => {
  const isPartiallyActive = ({ isPartiallyCurrent }) => ({
    className: `navbar-item m-auto has-text-weight-bold has-text-mitternachtsblau${isPartiallyCurrent ? " is-currently-active" : ""}`,
  })

  return (
    <div
      className="is-flex"
      style={{
        height: 70,
      }}
    >
      <Link to={link} getProps={isPartiallyActive}>
        <span className="header-link">{label}</span>
      </Link>
    </div>
  )
}
